import { formValidationProps, useFormValidation } from "@/components/organisms/mixins/form-validation.mixin";
import { formatPrix } from "@/composables/text-transformation";
import { useVuelidate } from "@vuelidate/core";

export const paymentMethodCarteMalinEurocoraProps = () => ({
  typeCarte: {
    type: String,
    required: true
  },
  montant: {
    type: Number,
    required: true
  },
  montantAdeduire: {
    type: [Number, String],
    required: false,
    default: 0
  },
  totalCommande: {
    type: Number,
    required: true
  },
  ...formValidationProps()
})

export const paymentMethodCarteMalinEurocoraEmits = () => ([
  "use",
  "cancel",
  "input"
])

export const usePaymentMethodCarteMalinEurocora = (props, context) => {
  const {
    getState,
    getErrorMessage,
    states
  } = useFormValidation(props)

  const internalMontantAdeduire = ref("")
  const isValid = ref(props.montantAdeduire > 0)
  const keyUtiliserTouteLaCagnotte = ref(0)
  const success = ref(false)

  const validations = computed(() => ({
    internalMontantAdeduire: {
      /* eslint-disable */
      max: function () {
        return montantIsNan.value ? true : montantAsFloat.value <= props.montant;
      },
      min: function () {
        return montantIsNan.value ? true : montantAsFloat.value >= 0;
      },
      numeric: function () {
        return internalMontantAdeduire.value === "" ? true : !montantIsNan.value;
      }
      /* eslint-enable */
    }
  }))

  const v$ = useVuelidate(validations, { internalMontantAdeduire })

  const montantIsNan = computed(() => {
    return isNaN(montantAsFloat.value);
  })
  const montantAsFloat = computed(() => {
    return parseFloat(internalMontantAdeduire.value.replace(",", "."));
  })
  const montantAsString = computed(() => {
    return formatPrix(props.montant);
  })
  const checkBoxDisabled = computed(() => {
    return montantIsNan.value || montantAsFloat.value === 0 || v$.$invalid;
  })

  const typeCarteLabel = computed(() => {
    return props.typeCarte === "malin" ? "malin" : "cora Cpay Mastercard";
  })

  const handleInput = () => {
    if (!montantIsNan.value && montantAsFloat.value > 0) {
      if (montantAsFloat.value > props.totalCommande || montantAsFloat.value > props.montant) {
        utiliserTouteLaCagnotte();
      }
      isValid.value = !v$.$invalid;
    } else {
      internalMontantAdeduire.value = "";
      isValid.value = false;
    }
  }
  const utiliserTouteLaCagnotte = () => {
    internalMontantAdeduire.value = formatPrix(props.montant < props.totalCommande ? props.montant : props.totalCommande);
    keyUtiliserTouteLaCagnotte.value++;
    context.emit('input', internalMontantAdeduire.value)
  }
  const handleBlur = () => {
    internalMontantAdeduire.value = formatPrix(montantAsFloat.value);
    keyUtiliserTouteLaCagnotte.value++;
  }
  const validate = () => {
    if (internalMontantAdeduire.value !== '') {
      context.emit('use', montantAsFloat.value)
      success.value = true
    }
  }
  const cancel = () => {
    success.value = false
    context.emit('cancel')
  }

  watch(() => props.montantAdeduire, (val) => {
    if (parseFloat(val) > 0) {
      internalMontantAdeduire.value = formatPrix(val);
    }
  }, { immediate: true })

  watch(internalMontantAdeduire, () => {
    handleInput()
  }, { immediate: true })

  return {
    v$,
    getState,
    getErrorMessage,
    states,
    internalMontantAdeduire,
    isValid,
    keyUtiliserTouteLaCagnotte,
    success,
    montantIsNan,
    montantAsFloat,
    montantAsString,
    checkBoxDisabled,
    typeCarteLabel,
    handleInput,
    utiliserTouteLaCagnotte,
    handleBlur,
    validate,
    cancel
  }
}
